import React from "react";
import { 
        Container, 
        Grid,
        Link,
    } from "@mui/material";
import styled from "@emotion/styled";

const MenuLink = styled(Link)`
    display: inline-block;
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
    font-family: "poppins"; 
    font-weight: 300;
    font-size: 15px;
    text-transform: uppercase;
    transition-duration: 0.5s;

    &:hover, &:active, &:focus{
        color: #00D3FD;
        transition-duration: 0.5s;
    }

    &:last-child{
        background: linear-gradient(225deg, #00D3FD, #7904FE, #F8063A);
        border-radius: 4px;
        border: unset;
        font-weight: 600;
        text-transform: unset;

        &:hover, &:active, &:focus{
            color: #ffffff;
            background: linear-gradient(225deg, #00D3FD 5%, #7904FE 50%, #F8063A 95%);
            box-shadow: 0 0 15px #00D3FD30, 0 0 25px #00D3FD30, 0 0 35px #00D3FD30;
        }
    }
`
const DesktopMenu = (props) => {
    const menulist = props.menuList.map(function(value, i){
        return (
            <MenuLink to={value[1]} className={value[2]}>
                {value[0]}
            </MenuLink>
        );
    });
    return (
        <Container maxWidth="xl">
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                className="Global---NavMenu py-4"
            >
                <Grid
                    xs={12}
                    sm={2}
                >
                    <Link to="/">
                        <img src={props.siteLogo} className="img-fluid w-100" style={{maxWidth: 170}} />
                    </Link>

                </Grid>
                <Grid
                    xs={12}
                    sm={10}
                    className="text-right"
                >
                    {menulist}
                </Grid>
            </Grid>
        </Container>
    );
}

export default DesktopMenu;
